// src/components/UiDialog.jsx
import React from "react";
import { Dialog } from "@blueprintjs/core";
import PropTypes from "prop-types";
import "./../css/UiDialog.scss";

class UiDialog extends React.Component {
  render() {
    const { isOpen, onClose, title, children, footer } = this.props;

    return (
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        className="ui-dialog"
        canOutsideClickClose={true}
        canEscapeKeyClose={true}
      >
        <div className="dialog-body">{children}</div>
        {footer && <div className="dialog-footer">{footer}</div>}
      </Dialog>
    );
  }
}

UiDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default UiDialog;
